// extracted by mini-css-extract-plugin
export var label = "_j0-0";
export var treatmentCard = "_j0-1";